import React from 'react'

const Footer = () => {
    return (
        <div style={{textAlign: "center", marginBottom: 5, color: "#FF0202"}}>
            Made with ♥️ by Harsh
        </div>
    )
}

export default Footer
